import { render, staticRenderFns } from "./certificateViewModal.vue?vue&type=template&id=60d420c8&scoped=true&"
import script from "./certificateViewModal.vue?vue&type=script&lang=js&"
export * from "./certificateViewModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateViewModal.vue?vue&type=style&index=0&id=60d420c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d420c8",
  null
  
)

export default component.exports